module.exports = __webpack_public_path__ + "kr.svg?7ce5a14098bfd2fb03e05cb0d1e178b4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/kr.svg
// module id = 1453
// module chunks = 0